import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { Attendance } from '../models/attendance'; 

@Injectable({
  providedIn: 'root'
})
export class AttendancesService {

  private  REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;

  constructor(private http:HttpClient) { }

  public getAttendance(filterParams:any=null):Observable<any>{
    return this.http.get<any>(`${this.REST_API_SERVER}/attendance`,{params:filterParams,observe:'response'});
  }

  public createAttendance(data:Attendance):Observable<Attendance>{
    return this.http.post<Attendance>(`${this.REST_API_SERVER}/attendance/create`,data);
  }

  public getThisWeekClockInAndClockOutTimes(filterParams:any=null):Observable<any>{
    return this.http.get<any>(`${this.REST_API_SERVER}/attendance/thisweeksigninandsignouts`,{params:filterParams,observe:'response'});
  }

  public getLastEventType():Observable<any>{
    return this.http.get<any>(`${this.REST_API_SERVER}/attendance/lasteventtype`);
  }

  public getWorkingTimeByDateRange(filterParams):Observable<any>{
    return this.http.post<any>(`${this.REST_API_SERVER}/attendance/workinghoursbydaterange`,filterParams);
  }
}
